export default {"src":"/_next/static/media/bank_icon_list.336a7fe3.svg","height":45,"width":248,"blurWidth":0,"blurHeight":0};